window.addEventListener("load", function() {
    // Initialize all swipers dynamically
    document.querySelectorAll('[data-swiper-main]').forEach(mainEl => {
        const type = mainEl.dataset.swiperMain;
        const thumbEl = document.querySelector(`[data-swiper-thumb="${type}"]`);

        if (thumbEl) {
            const thumbSwiper = new Swiper(thumbEl, {
                slidesPerView: 3,
                spaceBetween: 2,
                slideToClickedSlide: true,
                breakpoints: {
                    751: {
                        slidesPerView: 5,
                    }
                }
            });

            new Swiper(mainEl, {
                slidesPerView: "auto",
                centeredSlides: true,
                spaceBetween: 0,
                thumbs: {
                    swiper: thumbSwiper,
                },
                navigation: {
                    nextEl: mainEl.querySelector('.swiper-button-next'),
                    prevEl: mainEl.querySelector('.swiper-button-prev'),
                },
            });
        }
    });

    $(".tab__media--item").on("click", function() {
        $(this).addClass("active").siblings().removeClass("active");
        const target = $(this).data("target");
        $(target).addClass("active").siblings(".tab__image, .tab__video").removeClass("active");
    });
});